// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-shop {
    position: relative;
}

.product-shop__filters {
    background-color: var(--accent1);
    top: 180px;
    position: sticky;
    padding: .6rem;
    color: white;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    z-index: 1;
}

.product-shop__filters fieldset {
    margin-bottom: 1rem;
}

.product-shop__toolbar {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0.4rem;
    gap: 0.4rem;
} 

.product-shop__toolbar-controls {
    display: flex;
    gap: 0.4rem;
    flex-wrap: wrap;
}

.product-shop__controls {
    padding: .2rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.product-shop__btn {
    padding: .6rem 1.4rem;
    border: none;
    cursor: pointer;
    font-weight: 700;
    font-size: .7rem;
    text-transform: uppercase;
    font-family: var(--base-font);
}`, "",{"version":3,"sources":["webpack://./src/product-shop/product-shop.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;AACjC","sourcesContent":[".product-shop {\n    position: relative;\n}\n\n.product-shop__filters {\n    background-color: var(--accent1);\n    top: 180px;\n    position: sticky;\n    padding: .6rem;\n    color: white;\n    border-radius: 0.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    z-index: 1;\n}\n\n.product-shop__filters fieldset {\n    margin-bottom: 1rem;\n}\n\n.product-shop__toolbar {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    padding: 0.4rem;\n    gap: 0.4rem;\n} \n\n.product-shop__toolbar-controls {\n    display: flex;\n    gap: 0.4rem;\n    flex-wrap: wrap;\n}\n\n.product-shop__controls {\n    padding: .2rem;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n}\n\n.product-shop__btn {\n    padding: .6rem 1.4rem;\n    border: none;\n    cursor: pointer;\n    font-weight: 700;\n    font-size: .7rem;\n    text-transform: uppercase;\n    font-family: var(--base-font);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
